import { useEffect, useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./Reports.scss";
import { NumberFormatter } from "../../CommonFunction/NumberFormatter/NumberFormatter";
import { useNavigate } from "react-router-dom";

// Displays a single item in the menu. This component is designed to render individual account information.
const MenuItem = ({ account, type }) => {
  const navigate = useNavigate();
  console.log(account, "accountaccountaccountaccountaccount")
  if (account && account?.account?._id) {
    account = account.account;
  }

  const displayName = account.Account_Name || account.Business_Name || account.Proprietor_Name || account.BankAccount_Name || account.Name || account.Unique_Id;
  if (!displayName) {
    return null;
  }
  console.log(account)
  return (
    <li className="menu-item" onClick={(e) => {
      if (e.ctrlKey || e.metaKey) {
        // ✅ Handle Ctrl+Click or Cmd+Click here
        window.open(`/Ledger/${account?._id}/monthly`, '_blank');
        // your custom action...
      }
    }}>
      <span>{displayName}</span>
      <span>
        {/* {type === "liabilities"
          ? -1 * account.TotalClosingBalanceTillThat
          : type == "Assets"
          ? account.TotalClosingBalanceTillThat
          : type === "Income" || type === "Credit"
          ? -1 * account.TotalBalanceForThisPeriod
          : account.TotalBalanceForThisPeriod} */}
       
        {
          type === "liabilities"
            ? account.DisplaytotalClosingBalanceTillThat
            : type == "Assets"
              ? account.DisplaytotalClosingBalanceTillThat
              : type === "Income" || type === "Credit"
                ? account.DisplaytotalClosingBalanceTillThat
                : account.DisplaytotalClosingBalanceTillThat
        }
      </span>
    </li>
  );
};

// Manages and displays a group of accounts, including any sub-groups under it. It can expand or collapse its view to show or hide its contents.
// Shows the group's name and total balance. If `isOpen` is true, it renders a list of `MenuItem` components for each account and `GroupItem` components for each sub-group.
const GroupItem = ({ group, isAllExpanded, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setIsOpen(isAllExpanded);
  }, [isAllExpanded]);

  return (
    <>
      <div onClick={() => setIsOpen(!isOpen)} className="menu-group-title">
        <span>
          {group.AccountGroup.Account_Group} <MdKeyboardArrowDown className={`Dropdown ${isOpen ? "flipped" : ""}`} />
        </span>
        <span>
          {type === "liabilities" || type === "Income" || type === "Credit"
            ? group.DisplayGroupClosing // -1 * group.GroupClosing
            : group.DisplayGroupClosing}
        </span>
      </div>
      {isOpen && (
        <ul className="menu-group-items">
          {group.AccountGroup?.accounts.map((account, index) => (
            <MenuItem key={index} account={account} type={type} />
          ))}
          {group.GroupUnderData?.map((subGroup, index) => (
            <GroupItem key={index} group={subGroup} isAllExpanded={isAllExpanded} type={type} />
          ))}
        </ul>
      )}
    </>
  );
};

// A wrapper component for `GroupItem` to encapsulate each major group in the report.
// Simply wraps a `GroupItem` component in a div, effectively creating a block for each major group within the data.
const ReportGroup = ({ group, isAllExpanded, type }) => {
  return (
    <div className="menu-group">
      <GroupItem group={group} isAllExpanded={isAllExpanded} type={type} />
    </div>
  );
};

export default ReportGroup;
